var $3fc3bdd87c4b0a33$exports = {};
$3fc3bdd87c4b0a33$exports = {
    "help": `Hjelp`,
    "info": `Informasjon`
};


export {$3fc3bdd87c4b0a33$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
